(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["same-brand"] && !Shopify.designMode) return;
  try {
    
  class BrandFeed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = '1';

      const vendor = this.dataset.vendor;
      const pid = this.dataset.pid;
      const max = parseInt(this.dataset.max || '8', 10);
      const base = this.dataset.url;

      if (!vendor || !base) {
        this.remove();
        return;
      }

      let url = base + '?q=' + encodeURIComponent(vendor) + '&view=brand-feed';

      // Preserve the previewed theme so the correct template renders inside the theme editor.
      const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) {
        url += '&preview_theme_id=' + encodeURIComponent(previewId);
      }

      fetch(url)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((html) => {
          const parsed = document.createElement('div');
          parsed.innerHTML = html;

          let cards = Array.from(parsed.querySelectorAll('.bf2__card'));
          cards = cards.filter((card) => card.dataset.pid !== pid);

          if (cards.length === 0) {
            this.remove();
            return;
          }

          cards = cards.slice(0, max);

          const track = this.querySelector('.bf2__track');
          track.innerHTML = '';
          cards.forEach((card) => track.appendChild(card));

          this.initNav(track);
        })
        .catch(() => {
          this.remove();
        });
    }

    initNav(track) {
      const nav = this.querySelector('.bf2__nav');
      if (!nav) return;

      const update = () => {
        const overflowing = track.scrollWidth - track.clientWidth > 4;
        nav.hidden = !overflowing;
      };

      update();
      window.addEventListener('resize', update);

      nav.querySelectorAll('.bf2__arrow').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.dir === 'prev' ? -1 : 1;
          track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    }
  }

  if (!customElements.get('brand-feed')) {
    customElements.define('brand-feed', BrandFeed);
  }

  } catch(e) { console.error(e); }
})();
})();
